// this file is generated by update_shopify_store_data.py at 2026-01-26 20:25:35.817478
var courses = [
    {
        "course_id": "D24CEFEF-FBD1-F011-99C2-005056A7C6AF",
        "course_version": 1,
        "name": "VUSN: The Institute for Prevention and Whole Person Care",
        "course_type": 32,
        "author_information": "",
        "description": "This Vanderbilt University School of Nursing-developed domain offers a set of short, practical learning modules that strengthen whole-person and prevention-focused care. Topics include aging and cellular wellness, planetary health, trauma-informed communication, behavior change, and reflective practice. Courses are designed for busy clinicians and provide skills that improve patient relationships, support wellbeing, and enhance real-world care delivery.\r\n\r\nThe following courses are included:\r\nPlanetary Health: Foundations for a Healthier World\r\nPlanetary Health in Clinical Practice: Advocating for Patients in a Changing World\r\nNutrition for Successful Aging: Optimizing Healthspan\r\nTrauma-Informed Care\r\nHealthy Mitochondria, Healthy You: An Introduction to Cellular Wellness\r\nThe Science of Aging: Insights for Healthcare Professionals\r\nFoundational Communication: Guiding People Through Health-Related Behavior Change\r\nFrom Ambivalence to Action: Goal-Setting, Confidence, and Prevention in Practice\r\nAn Introduction to the 10 Caritas Processes\u00ae\r\nIntroduction to Qualitative Metasynthesis",
        "learning_objectives_html": "At the conclusion, participants should be able to:",
        "course_outline_html": "",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "059AA117-F9D1-F011-99C2-005056A7C6AF",
                "course_category_name": "Vanderbilt University School of Nursing - Prevention and Whole Person Care (Curriculum)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "5304C9CB-6EAB-F011-99AA-005056A77B46",
                "course_category_name": "Vanderbilt University School of Nursing",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": null,
            "accreditation_statement": null,
            "course_level_accreditation_statement": null,
            "credit_display_name": null,
            "credit_units": null,
            "credit_unit_display_name": null
        },
        "sub_courses": [
            {
                "course_id": "235E6FE9-27BB-F011-99A0-005056A78EAA",
                "course_version": 1,
                "name": "Foundational Communication: Guiding People Through Health-Related Behavior Change",
                "course_type": 1,
                "author_information": "Annie Youngblood, NBC-HWC",
                "description": "This e-learning\u00a0introduces a powerful, evidence-based approach to communication grounded in trust, curiosity, and partnership. You\u2019ll learn how to build collaborative relationships, apply core skills from Motivational Interviewing, and engage patients in conversations that support change. Whether you're working in behavioral health, primary care, or community outreach, these skills help create more meaningful, effective interactions.",
                "learning_objectives_html": "This module introduces providers to a collaborative approach in patient and client care, emphasizing partnership, mutual respect, and shared decision-making. The goal is to move beyond traditional hierarchies and objectives, focusing instead on building relationships that empower patients and encourage active participation in their own healthcare processes.<br />\r\n<br />\r\nBy the end of this module, you should be able to:\r\n<ol>Define the differences in a directive and prescriptive approach vs. a collaborative, patient-empowered approach to care\r\n</ol>\r\n<ol>List some of the key skills that support a patient-first approach\r\n</ol>\r\n<ol>Understand the basic characteristics of growth-fostering relationships and how they impact your ability to provide effective support\r\n</ol>\r\n<ol>Describe the research on relationship variables and psychotherapy outcomes\r\n</ol>\r\n<ol>Characterize the evidence-supported relationship factors that create a strong relationship\r\n</ol>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "5936B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Behavioral Health Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DC33B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Leadership Development",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5304C9CB-6EAB-F011-99AA-005056A77B46",
                        "course_category_name": "Vanderbilt University School of Nursing",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "222C7486-35D4-E511-93E1-005056B12CFE",
                        "course_category_name": "Interpersonal Relationships",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "EBDFBCD4-F8D1-F011-99C2-005056A7C6AF",
                        "course_category_name": "Vanderbilt University School of Nursing - Prevention and Whole Person Care (COURSES)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5CF89115-F6D1-F011-99C2-005056A7C6AF",
                        "course_category_name": "Vanderbilt University School of Nursing: Foundational Communication: Guiding People Through Health-Related Behavior Change",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7250EEC8-F7D1-F011-99C2-005056A7C6AF",
                        "course_category_name": "Vanderbilt University School of Nursing - Foundational Communication: Guiding People Through Health-Related Behavior Change",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7D6135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "All Disciplines",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "31589936-71AB-F011-99AA-005056A77B46",
                        "course_category_name": "Vanderbilt University School of Nursing - Individual Courses",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "Vanderbilt University School of Nursing is accredited as a provider of nursing continuing professional development by the American Nurses Credentialing Center&rsquo;s Commission on Accreditation.\r\n<br />\r\n<br />\r\nThis activity will award 4 contact hours to participants who complete all sections and and the course survey.  No partial credit will be given.\r\n<br />\r\n<br />\r\nThere are no financial relationships to disclose.",
                    "credit_display_name": "ANCC CNE Credit",
                    "credit_units": 4.0,
                    "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "35D9D597-27BB-F011-99A0-005056A78EAA",
                "course_version": 1,
                "name": "Planetary Health: Foundations for a Healthier World",
                "course_type": 1,
                "author_information": "Carol Zigler, DNP, FNP-C, APHN-BC",
                "description": "Planetary Health explores how climate change and environmental shifts directly impact our health\u2014from the air we breathe to the food we eat and the diseases we face. This interactive course breaks down complex issues into real-world examples, showing how extreme heat, air pollution, and ecological changes are not just environmental problems, but urgent human ones. You\u2019ll learn how communities are responding, why global frameworks like the S\u00e3o Paulo Declaration matter, and what actions can lead to a healthier, more sustainable future for all.",
                "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ol>Define the concept of Planetary Health and explain its relevance to clinical practice and public well-being. </ol>\r\n    <ol>Identify key environmental changes (e.g., climate change, pollution) and describe their direct and indirect impacts on human health. </ol>\r\n        <ol>Analyze real-world case examples that illustrate the connection between environmental factors and patient health outcomes. </ol>\r\n            <ol>Describe individual, clinical, and community-level strategies that promote both environmental sustainability and human health.\r\n            </ol>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "DC33B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Leadership Development",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5304C9CB-6EAB-F011-99AA-005056A77B46",
                        "course_category_name": "Vanderbilt University School of Nursing",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3612D096-F5D1-F011-99C2-005056A7C6AF",
                        "course_category_name": "Vanderbilt University School of Nursing: Planetary Health: Foundations for a Healthier World",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7D6135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "All Disciplines",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C15CE9E2-F6D1-F011-99C2-005056A7C6AF",
                        "course_category_name": "Vanderbilt University School of Nursing - Planetary Health: Foundations for a Healthier World",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "31589936-71AB-F011-99AA-005056A77B46",
                        "course_category_name": "Vanderbilt University School of Nursing - Individual Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "EBDFBCD4-F8D1-F011-99C2-005056A7C6AF",
                        "course_category_name": "Vanderbilt University School of Nursing - Prevention and Whole Person Care (COURSES)",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "Vanderbilt University School of Nursing is accredited as a provider of nursing continuing professional development by the American Nurses Credentialing Center&rsquo;s Commission on Accreditation.\r\n<br />\r\n<br />\r\nThis activity will award 0.75 contact hours to participants who complete all sections and pass the assessment with a score of 80% or greater.  No partial credit will be given.\r\n<br />\r\n<br />\r\nThere are no financial relationships to disclose.",
                    "credit_display_name": "ANCC CNE Credit",
                    "credit_units": 0.75,
                    "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "AB55FF0F-28BB-F011-99A0-005056A78EAA",
                "course_version": 1,
                "name": "Introduction to Qualitative Metasynthesis",
                "course_type": 1,
                "author_information": "Julie Barroso, PhD, ANP, FNAP, FAAN",
                "description": "Have you ever wondered how to bring together insights from multiple qualitative studies to inform practice and policy? This course will guide you through the foundational concepts, rationale, and practical steps of qualitative metasynthesis, an advanced method for synthesizing qualitative research. You will learn to define qualitative metasynthesis, understand its importance in evidence-based practice, design a robust study, and differentiate appropriate studies for inclusion. Through a structured, supportive, and academically rigorous approach, you will gain the skills needed to conduct and appraise qualitative metasynthesis in health, social science, or nursing research.",
                "learning_objectives_html": "By the end of this module, learners will be able to:\r\n<ol>Define qualitative metasynthesis and explain its dual nature as both a product and a process.</ol>\r\n    <ol>Describe the rationale for conducting qualitative metasynthesis and its role in advancing evidence-based practice.\r\n    </ol>\r\n    <ol>Identify key components and considerations in designing a qualitative metasynthesis study, including topic selection, population parameters, and time frame.\r\n    </ol>\r\n    <ol>Differentiate qualitative research from other types of studies and understand inclusion/exclusion criteria for synthesis.\r\n    </ol>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "EBDFBCD4-F8D1-F011-99C2-005056A7C6AF",
                        "course_category_name": "Vanderbilt University School of Nursing - Prevention and Whole Person Care (COURSES)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "CE359C4F-F8D1-F011-99C2-005056A7C6AF",
                        "course_category_name": "Vanderbilt University School of Nursing - Introduction to Qualitative Metasynthesis",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5304C9CB-6EAB-F011-99AA-005056A77B46",
                        "course_category_name": "Vanderbilt University School of Nursing",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "31589936-71AB-F011-99AA-005056A77B46",
                        "course_category_name": "Vanderbilt University School of Nursing - Individual Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "81F5DF4F-F6D1-F011-99C2-005056A7C6AF",
                        "course_category_name": "Vanderbilt University School of Nursing: Introduction to Qualitative Metasynthesis",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DC33B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Leadership Development",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7D6135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "All Disciplines",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "463623AC-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Personal Development",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "Vanderbilt University School of Nursing is accredited as a provider of nursing continuing professional development by the American Nurses Credentialing Center&rsquo;s Commission on Accreditation.\r\n<br />\r\n<br />\r\nThis activity will award 2.5 contact hours to participants who complete all sections and complete the post course survey.  No partial credit will be given.\r\n<br />\r\n<br />\r\nThere are no financial relationships to disclose.",
                    "credit_display_name": "ANCC CNE Credit",
                    "credit_units": 2.5,
                    "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "6A1D3FBB-27BB-F011-99A0-005056A78EAA",
                "course_version": 1,
                "name": "Listen. Validate. Empower: A Trauma-Informed Communication Series",
                "course_type": 1,
                "author_information": "Diana Dinkel, MSN, FNP-C, ENP-C",
                "description": "Listen. Validate. Empower: A Trauma-Informed Communication Series is a practical training series designed to help professionals in healthcare, and social services engage in effective, compassionate communication with individuals affected by trauma. Grounded in trauma-informed principles\u2014safety, trust, collaboration, empowerment, and cultural sensitivity\u2014this course provides actionable strategies for handling complex interactions across diverse scenarios. Topics include foundational trauma-informed care, vicarious trauma, motivational interviewing, conflict resolution, suicide prevention, domestic violence, abuse, human trafficking, and risk reduction. Through these focused modules, learners will build skills to recognize trauma, respond with empathy, de-escalate conflict, and foster respectful, healing-centered environments.",
                "learning_objectives_html": "By the end of this course, participants will be able to:\r\n<ol>Define the core principles of trauma-informed care and explain their relevance across healthcare, and social service settings.\r\n</ol>\r\n<ol>Identify signs and impacts of trauma in individuals and communities, including vicarious trauma experienced by professionals.\r\n</ol>\r\n<ol>Demonstrate trauma-informed communication techniques that prioritize safety, trust, and empowerment during challenging interactions.\r\n</ol>\r\n<ol>Apply motivational interviewing skills using a trauma-informed lens to support behavior change and person-centered care.\r\n</ol>\r\n<ol>Navigate difficult conversations related to conflict, suicide prevention, abuse, and exploitation with empathy, clarity, and appropriate referral strategies.\r\n</ol>\r\n<ol>Recognize and manage secondary traumatic stress and develop strategies for self-care and resilience in high-impact roles.\r\n</ol>\r\n<ol>Foster environments that reduce risk and support healing, especially when working with vulnerable populations or in high-stress community settings.</ol>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "64AC0E63-34D4-E511-93E1-005056B12CFE",
                        "course_category_name": "Patient Advocacy",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FB9558A0-F7D1-F011-99C2-005056A7C6AF",
                        "course_category_name": "Vanderbilt University School of Nursing - Listen. Validate. Empower: A Trauma-Informed Communication Series",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2D0703A4-DFA9-EB11-80E1-005056B17C18",
                        "course_category_name": "Patient Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A0CBF9A6-C98C-EB11-80DF-005056B134EC",
                        "course_category_name": "Child Abuse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FA20BE9F-C98C-EB11-80DF-005056B134EC",
                        "course_category_name": "Elder Abuse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0E34B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Patient Rights",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5304C9CB-6EAB-F011-99AA-005056A77B46",
                        "course_category_name": "Vanderbilt University School of Nursing",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "57DADFC8-E203-E911-A43F-005056B13721",
                        "course_category_name": "Sexual Abuse & Assault",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7D6135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "All Disciplines",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "31589936-71AB-F011-99AA-005056A77B46",
                        "course_category_name": "Vanderbilt University School of Nursing - Individual Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C3927507-F6D1-F011-99C2-005056A7C6AF",
                        "course_category_name": "Vanderbilt University School of Nursing: Listen. Validate. Empower: A Trauma-Informed Communication Series",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "20607355-35D4-E511-93E1-005056B12CFE",
                        "course_category_name": "Patient Needs",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "EBDFBCD4-F8D1-F011-99C2-005056A7C6AF",
                        "course_category_name": "Vanderbilt University School of Nursing - Prevention and Whole Person Care (COURSES)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "51FB57AE-C98C-EB11-80DF-005056B134EC",
                        "course_category_name": "Intimate Partner Violence",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "Vanderbilt University School of Nursing is accredited as a provider of nursing continuing professional development by the American Nurses Credentialing Center&rsquo;s Commission on Accreditation.\r\n<br />\r\n<br />\r\nThis activity will award 4 contact hours to participants who complete all sections and pass the assessment with a score of 80% or greater.  No partial credit will be given.\r\n<br />\r\n<br />\r\nThere are no financial relationships to disclose.",
                    "credit_display_name": "ANCC CNE Credit",
                    "credit_units": 4.0,
                    "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "FD63D42A-28BB-F011-99A0-005056A78EAA",
                "course_version": 1,
                "name": "An Introduction to the 10 Caritas Processes\u00ae",
                "course_type": 1,
                "author_information": "Watson Caring Science Institute",
                "description": "Caring Science, developed by Dr. Jean Watson, invites us to see caring as a way of being grounded in human connection and evidence-based practice. This course introduces the 10 Caritas Processes\u00ae as guiding commitments to compassion, presence, and whole-person care. Through reflections and stories from Dr. Gloria Littlemouse, you will see how these processes come to life in practice\u2014offering insight, resilience, and inspiration for nursing in moments of both challenge and healing.",
                "learning_objectives_html": "By the end of the course, learners will be able to:\r\n<ol>Describe the philosophy of Caring Science and the 10 Caritas Processes&reg; as foundations for compassionate, evidence-based nursing practice.</ol>\r\n    <ol>Analyze case examples and stories to determine how the Caritas Processes&reg; are demonstrated in real-world nursing encounters.</ol>\r\n        <ol>Develop a personal action plan to integrate the Caritas Processes&reg; into daily practice to enhance healing relationships and resilience.</ol>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "5304C9CB-6EAB-F011-99AA-005056A77B46",
                        "course_category_name": "Vanderbilt University School of Nursing",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "77F16213-F8D1-F011-99C2-005056A7C6AF",
                        "course_category_name": "Vanderbilt University School of Nursing - An Introduction to the 10 Caritas Processes\u00ae",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "EBDFBCD4-F8D1-F011-99C2-005056A7C6AF",
                        "course_category_name": "Vanderbilt University School of Nursing - Prevention and Whole Person Care (COURSES)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "31589936-71AB-F011-99AA-005056A77B46",
                        "course_category_name": "Vanderbilt University School of Nursing - Individual Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DCFCDA08-33D4-E511-93E1-005056B12CFE",
                        "course_category_name": "Care Coordination",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6FCCD559-0EBF-E211-97A9-001517135213",
                        "course_category_name": "Cardiac Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7D6135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "All Disciplines",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F02E223C-F6D1-F011-99C2-005056A7C6AF",
                        "course_category_name": "Vanderbilt University School of Nursing: An Introduction to the 10 Caritas Processes\u00ae",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "Vanderbilt University School of Nursing is accredited as a provider of nursing continuing professional development by the American Nurses Credentialing Center&rsquo;s Commission on Accreditation.\r\n<br />\r\n<br />\r\nThis activity will award 2.5 contact hours to participants who complete all sections and pass the assessment with a score of 80% or greater.  No partial credit will be given.\r\n<br />\r\n<br />\r\nThere are no financial relationships to disclose.",
                    "credit_display_name": "ANCC CNE Credit",
                    "credit_units": 2.5,
                    "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "4809F33E-28BB-F011-99A0-005056A78EAA",
                "course_version": 1,
                "name": "From Ambivalence to Action: Goal-Setting, Confidence, and Prevention in Practice",
                "course_type": 1,
                "author_information": "Annie Youngblood, NBC-HWC",
                "description": "This course focuses on what happens after the conversation about health-related behavior change has begun\u2014how to clarify values, set realistic goals, and move forward even when confidence is low. You\u2019ll explore strategies for goal-setting, confidence scaling, and real-time support in brief encounters. The course also highlights prevention, whole-person care, and the impact of social determinants of health. Through applied case studies, you\u2019ll learn practical, evidence-based approaches for guiding change in everyday clinical realities.",
                "learning_objectives_html": "By the end of this course, leaners will be able to:\r\n<ol>Analyze key theories and principles of health behavior change and their application to clinical and community practice.\r\n</ol>\r\n<ol>Demonstrate values-driven, person-centered strategies to explore motivation, clarify goals, and address ambivalence.\r\n</ol>\r\n<ol>Differentiate between behavioral and outcome goals to support the development of realistic, actionable next steps.\r\n</ol>\r\n<ol>Apply communication techniques&mdash;including powerful questioning, summarizing, confidence scaling, and brief interventions&mdash;to guide real-time conversations.\r\n</ol>\r\n<ol>Integrate prevention, whole-person care, and social determinants of health into behavior change discussions that promote long-term well-being.\r\n</ol>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "EBDFBCD4-F8D1-F011-99C2-005056A7C6AF",
                        "course_category_name": "Vanderbilt University School of Nursing - Prevention and Whole Person Care (COURSES)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "31589936-71AB-F011-99AA-005056A77B46",
                        "course_category_name": "Vanderbilt University School of Nursing - Individual Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7D6135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "All Disciplines",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "222C7486-35D4-E511-93E1-005056B12CFE",
                        "course_category_name": "Interpersonal Relationships",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DC33B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Leadership Development",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AE7EFAF2-F7D1-F011-99C2-005056A7C6AF",
                        "course_category_name": "Vanderbilt University School of Nursing - From Ambivalence to Action: Goal-Setting, Confidence, and Prevention in Practice",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "EE68B22F-F6D1-F011-99C2-005056A7C6AF",
                        "course_category_name": "Vanderbilt University School of Nursing: From Ambivalence to Action: Goal-Setting, Confidence, and Prevention in Practice",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5304C9CB-6EAB-F011-99AA-005056A77B46",
                        "course_category_name": "Vanderbilt University School of Nursing",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "Vanderbilt University School of Nursing is accredited as a provider of nursing continuing professional development by the American Nurses Credentialing Center&rsquo;s Commission on Accreditation.\r\n<br />\r\n<br />\r\nThis activity will award 4.5 contact hours to participants who complete all sections and pass the assessment with a score of 80% or greater.  No partial credit will be given.\r\n<br />\r\n<br />\r\nThere are no financial relationships to disclose.",
                    "credit_display_name": "ANCC CNE Credit",
                    "credit_units": 4.5,
                    "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "7AD46538-27BB-F011-99A0-005056A78EAA",
                "course_version": 1,
                "name": "Planetary Health in Clinical Practice: Advocating for Patients in a Changing World",
                "course_type": 1,
                "author_information": "Carol Zigler, DNP, FNP-C, APHN-BC",
                "description": "As the climate crisis accelerates, clinicians are uniquely positioned to address its health impacts at every level\u2014from the exam room to health systems. This course equips healthcare professionals with the knowledge and tools to recognize environmental drivers of illness, apply Planetary Health principles in clinical care, and promote sustainable, equitable practices that benefit both patients and the planet. Through practical strategies, real-world examples, and a focus on advocacy, learners will gain a clear understanding of how to take meaningful action in a changing world.",
                "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ol>Define Planatary Health and explain its relevance to clinical care; </ol>\r\n    <ol>Recognize how environmental and climate-related factors contribute to patient risk and outcomes; </ol>\r\n        <ol>Identify opportunities to deliver care that supports both health and sustainability; </ol>\r\n            <ol>Understand the role of climate justice in addressing health dispartities; </ol>\r\n                <ol>Advocate for your patients by intergrating Planetary Health principles into your everyday practice.\r\n                </ol>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "31589936-71AB-F011-99AA-005056A77B46",
                        "course_category_name": "Vanderbilt University School of Nursing - Individual Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7D6135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "All Disciplines",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "463623AC-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Personal Development",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "809D92BA-F5D1-F011-99C2-005056A7C6AF",
                        "course_category_name": "Vanderbilt University School of Nursing: Planetary Health in Clinical Practice: Advocating for Patients in a Changing World",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "54BD2843-F7D1-F011-99C2-005056A7C6AF",
                        "course_category_name": "Vanderbilt University School of Nursing - Planetary Health in Clinical Practice: Advocating for Patients in a Changing World",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "EBDFBCD4-F8D1-F011-99C2-005056A7C6AF",
                        "course_category_name": "Vanderbilt University School of Nursing - Prevention and Whole Person Care (COURSES)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5304C9CB-6EAB-F011-99AA-005056A77B46",
                        "course_category_name": "Vanderbilt University School of Nursing",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DC33B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Leadership Development",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "Vanderbilt University School of Nursing is accredited as a provider of nursing continuing professional development by the American Nurses Credentialing Center&rsquo;s Commission on Accreditation.\r\n<br />\r\n<br />\r\nThis activity will award 0.5 contact hours to participants who complete all sections and pass the assessment with a score of 80% or greater.  No partial credit will be given.\r\n<br />\r\n<br />\r\nThere are no financial relationships to disclose.",
                    "credit_display_name": "ANCC CNE Credit",
                    "credit_units": 0.5,
                    "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "492BD37C-27BB-F011-99A0-005056A78EAA",
                "course_version": 1,
                "name": "Nutrition for Successful Aging: Optimizing Healthspan",
                "course_type": 1,
                "author_information": "Carol Zigler, DNP, FNP-C, APHN-BC",
                "description": "As we live longer lives, nutrition plays a critical role in supporting health, independence, and quality of life\u2014but aging doesn\u2019t happen in a vacuum. Climate change, disrupted food systems, and environmental stressors increasingly affect how and what we eat, especially for older adults. This course examines the intersection of aging, nutrition, and Planetary Health, exploring how food access, equity, and sustainability shape the aging experience. Through a justice-focused lens, you\u2019ll learn how to support healthy aging in individuals and communities while building resilience for future generations.",
                "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ol>Explain how aging affects nutritional needs and identify key dietary patterns that support health and longevity in older adults. </ol>\r\n    <ol>Analyse the impact of climate change and food systems on nutrition and health outcomes among aging populations. </ol>\r\n        <ol>Apply Planetary Health principles to develop strategies that promote equitable, sustainable nutrition for older adults at individual and community levels.\r\n        </ol>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "31589936-71AB-F011-99AA-005056A77B46",
                        "course_category_name": "Vanderbilt University School of Nursing - Individual Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "62F4CAD0-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nutrition",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "EBDFBCD4-F8D1-F011-99C2-005056A7C6AF",
                        "course_category_name": "Vanderbilt University School of Nursing - Prevention and Whole Person Care (COURSES)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C48CC568-F7D1-F011-99C2-005056A7C6AF",
                        "course_category_name": "Vanderbilt University School of Nursing - Nutrition for Successful Aging: Optimizing Healthspan",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "71021ACF-F5D1-F011-99C2-005056A7C6AF",
                        "course_category_name": "Vanderbilt University School of Nursing: Nutrition for Successful Aging: Optimizing Healthspan",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5304C9CB-6EAB-F011-99AA-005056A77B46",
                        "course_category_name": "Vanderbilt University School of Nursing",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E64A7C75-8EC5-E811-AEE3-005056B11CD6",
                        "course_category_name": "Population Health Management",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D6EC53E-1F26-E711-9EDE-005056B14F90",
                        "course_category_name": "Geriatric Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7D6135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "All Disciplines",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "Vanderbilt University School of Nursing is accredited as a provider of nursing continuing professional development by the American Nurses Credentialing Center&rsquo;s Commission on Accreditation.\r\n<br />\r\n<br />\r\nThis activity will award 0.5 contact hours to participants who complete all sections and pass the assessment with a score of 80% or greater.  No partial credit will be given.\r\n<br />\r\n<br />\r\nThere are no financial relationships to disclose.",
                    "credit_display_name": "ANCC CNE Credit",
                    "credit_units": 0.5,
                    "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "3590526F-4EF4-EF11-9992-005056A7DAD4",
                "course_version": 2,
                "name": "The Science of Aging Well: Insights for Healthcare Professionals",
                "course_type": 1,
                "author_information": "Cathy Maxwell, PhD, RN, FAAN, FNAP",
                "description": "Aging is the single most risk factor for chronic disease, functional decline, frailty, morbidity and mortality. Aging, as a risk factor, far outweighs genetic and environmental influences, yet biological mechanisms that lead to avoidable outcomes are poorly understood by both clinicians and the public-at-large. Today\u2019s health care clinicians need to be equipped with a basic understanding of biological principles of healthy aging so that that they can translate them to the public. This course promotes a paradigm shift towards geroscience, the intersection of basic aging biology, chronic disease and health. The course will provide front line clinicians with knowledge and skills to assist patients and communities with proactive planning for health-related quality of life and longevity. Learners will gain an understanding of the hallmarks of aging, with particular emphasis on mitochondrial function. The course will also provide a roadmap for assisting patients with goal setting in targeted areas of prevention that are essential for healthy aging.",
                "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<li>Describe the difference between chronological aging and biological aging\r\n</li>\r\n<li>Apply knowledge about biological aging and frailty screenings to application of screening processes for various clinical settings\r\n</li>\r\n<li>Explain the role of mitochondria as an aging driver and topic of focus for healthy aging\r\n</li>\r\n<li>Explain preventive measures for proactive planning for healthy aging</li>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "00A65374-1B26-E711-9EDE-005056B14F90",
                        "course_category_name": "Alternative Medicine",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3F30DEBA-C7B8-F011-999F-005056A78EAA",
                        "course_category_name": "Vanderbilt University School of Nursing: The Science of Aging Well: Insights for Healthcare Professionals",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A2B7FF67-CEC9-E511-82AF-005056B150D3",
                        "course_category_name": "End of Life Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D0B2F3ED-33D4-E511-93E1-005056B12CFE",
                        "course_category_name": "Psychosocial Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DCFCDA08-33D4-E511-93E1-005056B12CFE",
                        "course_category_name": "Care Coordination",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "EBDFBCD4-F8D1-F011-99C2-005056A7C6AF",
                        "course_category_name": "Vanderbilt University School of Nursing - Prevention and Whole Person Care (COURSES)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5304C9CB-6EAB-F011-99AA-005056A77B46",
                        "course_category_name": "Vanderbilt University School of Nursing",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D6EC53E-1F26-E711-9EDE-005056B14F90",
                        "course_category_name": "Geriatric Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E64A7C75-8EC5-E811-AEE3-005056B11CD6",
                        "course_category_name": "Population Health Management",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "31589936-71AB-F011-99AA-005056A77B46",
                        "course_category_name": "Vanderbilt University School of Nursing - Individual Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7D6135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "All Disciplines",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "62F4CAD0-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nutrition",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6FCCD559-0EBF-E211-97A9-001517135213",
                        "course_category_name": "Cardiac Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8F6B91A1-C8B8-F011-999F-005056A78EAA",
                        "course_category_name": "Vanderbilt University School of Nursing: The Science of Aging Well: Insights for Healthcare Professionals",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "Vanderbilt University School of Nursing is accredited as a provider of nursing continuing professional development by the American Nurses Credentialing Center&rsquo;s Commission on Accreditation.\r\n<br />\r\n<br />\r\nThis activity will award 2.5 contact hours to participants who complete all sections and pass the assessment with a score of 90% or greater.  No partial credit will be given.\r\n<br />\r\n<br />\r\nThere are no financial relationships to disclose.",
                    "credit_display_name": "ANCC CNE Credit",
                    "credit_units": 2.5,
                    "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "C7A4D921-60F4-EF11-9992-005056A7DAD4",
                "course_version": 3,
                "name": "Healthy Mitochondria, Healthy You: An Introduction to Cellular Wellness",
                "course_type": 1,
                "author_information": "Cathy Maxwell, PhD, RN, FAAN, FNAP",
                "description": "We are all aging however the pace and impact of our aging on our overall health depends on a myriad of factors, some within our control and others not. As healthcare professionals, these microlearnings offer you the opportunity to learn about the importance of mitochondria in the aging process and understand how development of a proactive aging plan can assist in maintaining mitochondrial fitness and promoting healthy aging. You can use this information to help yourself, your loved ones, and your patients.",
                "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<li>Describe how the role mitochondria play in our overall aging and health.\r\n</li>\r\n<li>Apply knowledge on tools and resources available to develop a healthy exercise plan for yourself and patients\r\n</li>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "7D6135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "All Disciplines",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D6EC53E-1F26-E711-9EDE-005056B14F90",
                        "course_category_name": "Geriatric Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E64A7C75-8EC5-E811-AEE3-005056B11CD6",
                        "course_category_name": "Population Health Management",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "00A65374-1B26-E711-9EDE-005056B14F90",
                        "course_category_name": "Alternative Medicine",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D0B2F3ED-33D4-E511-93E1-005056B12CFE",
                        "course_category_name": "Psychosocial Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E28C907C-6FAB-F011-99AA-005056A77B46",
                        "course_category_name": "Vanderbilt University School of Nursing - Healthy Mitochondria, Healthy You: An Introduction to Cellular Wellness",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "93FD0740-6FAB-F011-99AA-005056A77B46",
                        "course_category_name": "Vanderbilt University School of Nursing: Healthy Mitochondria, Healthy You: An Introduction to Cellular Wellness",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A2B7FF67-CEC9-E511-82AF-005056B150D3",
                        "course_category_name": "End of Life Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DCFCDA08-33D4-E511-93E1-005056B12CFE",
                        "course_category_name": "Care Coordination",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "62F4CAD0-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nutrition",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "31589936-71AB-F011-99AA-005056A77B46",
                        "course_category_name": "Vanderbilt University School of Nursing - Individual Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "EBDFBCD4-F8D1-F011-99C2-005056A7C6AF",
                        "course_category_name": "Vanderbilt University School of Nursing - Prevention and Whole Person Care (COURSES)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5304C9CB-6EAB-F011-99AA-005056A77B46",
                        "course_category_name": "Vanderbilt University School of Nursing",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "Vanderbilt University School of Nursing is accredited as a provider of nursing continuing professional development by the American Nurses Credentialing Center&rsquo;s Commission on Accreditation.\r\n<br />\r\n<br />\r\nThis activity will award 1 contact hour to participants who complete all sections and pass the assessment with a score of 90% or greater.  No partial credit will be given.\r\n<br />\r\n<br />\r\nThere are no financial relationships to disclose.",
                    "credit_display_name": "ANCC CNE Credit",
                    "credit_units": 1.0,
                    "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
                },
                "sub_courses": []
            }
        ]
    }
];